import * as React from "react";

import { Plant } from "../../generator/model";
import { PlantIcon } from "../Icon/Icon";

type Option = {
  plant: Plant;
  isSelected: boolean;
};
interface Props {
  list: Option[];
  highlightColor?: string;
  onChange: (list: Option[]) => void;
}

export const PlantSelect = (props: Props) => {
  const { list, onChange } = props;
  const highlightColor = props?.highlightColor ?? "#A10400";
  // const a = React.useCallback(() => {});

  const [selectedPlants, setSelectedPlants] = React.useState(
    list.filter((o) => o.isSelected).map((o) => o.plant)
  );
  const selectedPlantNames = selectedPlants.map((p) => p.name);

  React.useEffect(() => {
    onChange(
      list.map((option) => ({
        ...option,
        isSelected: selectedPlantNames.includes(option.plant.name),
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlantNames.join(",")]);

  return (
    <div
      className="d-flex"
      style={{
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      {list.map((option, i) => {
        const { plant } = option;
        const isSelected = selectedPlantNames.includes(plant.name);
        return (
          <div
            key={plant.name + i}
            style={{
              margin: "5px 12px",
              cursor: "pointer",
              ...(isSelected
                ? { boxShadow: "0px 0px 2px 5px " + highlightColor }
                : null),
            }}
            onClick={() => {
              if (isSelected) {
                setSelectedPlants(
                  selectedPlants.filter((p) => p.name !== plant.name)
                );
              } else {
                setSelectedPlants([...selectedPlants, plant]);
              }
              // onChange(
              //   list.map((option) => ({
              //     ...option,
              //     isSelected: selectedPlantNames.includes(option.plant.name),
              //   }))
              // );
            }}
          >
            <PlantIcon name={plant.name} />
          </div>
        );
      })}
    </div>
  );
};
